import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { formatTime12Hour } from './timeFormat';

export const generateReceiptPDF = (receipt) => {
  const doc = new jsPDF();
  
  // Set colors
  const aqua = [6, 182, 212]; // #06B6D4
  const coral = [255, 127, 80]; // #FF7F50
  const darkGray = [55, 65, 81];
  
  // Header - Aqua strip
  doc.setFillColor(...aqua);
  doc.rect(0, 0, 210, 30, 'F');
  
  // Logo placeholder (you'll add actual logo later)
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 255, 255);
  doc.text('TAXI-98', 15, 15);
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text('Your trusted ride in Nassau', 15, 22);
  
  // Receipt title
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('RECEIPT', 195, 15, { align: 'right' });
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text(receipt.reference, 195, 22, { align: 'right' });
  
  let yPos = 45;
  
  // Customer Information
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...darkGray);
  doc.text('Customer Information', 15, yPos);
  yPos += 8;
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Customer Name: ${receipt.customerName}`, 15, yPos);
  yPos += 6;
  doc.text(`Email: ${receipt.customerEmail}`, 15, yPos);
  yPos += 12;
  
  // Trip Details
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text('Trip Details', 15, yPos);
  yPos += 8;
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Date: ${receipt.tripDate}`, 15, yPos);
  yPos += 6;
  doc.text(`Drop-off Time: ${formatTime12Hour(receipt.dropoffTime)}`, 15, yPos);
  yPos += 6;
  doc.text(`Pickup Location: ${receipt.pickupLocation}`, 15, yPos);
  yPos += 6;
  doc.text(`Drop-off Location: ${receipt.dropoffLocation}`, 15, yPos);
  yPos += 6;
  doc.text(`Driver: ${receipt.driverName}${receipt.driverId ? ` (ID: ${receipt.driverId})` : ''}`, 15, yPos);
  yPos += 12;
  
  // Fare Information - Highlighted box
  doc.setFillColor(224, 247, 250); // Light cyan
  doc.rect(15, yPos, 180, 25, 'F');
  
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...aqua);
  doc.text('Fare Collected', 20, yPos + 10);
  
  doc.setFontSize(20);
  doc.text(`$${Number(receipt.fareCollected).toFixed(2)} BSD`, 195, yPos + 10, { align: 'right' });
  
  yPos += 30;
  
  // Payment Note
  doc.setFillColor(254, 252, 232); // Light yellow
  doc.rect(15, yPos, 180, 15, 'F');
  
  doc.setFontSize(9);
  doc.setFont('helvetica', 'italic');
  doc.setTextColor(...darkGray);
  doc.text(`Note: ${receipt.notes}`, 20, yPos + 10);
  
  yPos += 20;
  
  // Disclaimer
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(100, 100, 100);
  const disclaimerText = 'Disclaimer: This receipt is for record purposes only. No online payment was processed. Payment was collected directly by the driver.';
  const splitDisclaimer = doc.splitTextToSize(disclaimerText, 180);
  doc.text(splitDisclaimer, 15, yPos);
  
  // Footer - Aqua strip
  doc.setFillColor(...aqua);
  doc.rect(0, 270, 210, 27, 'F');
  
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(255, 255, 255);
  doc.text('Phone: +1 (242) 810-7335', 15, 280);
  doc.text('Email: bookings@taxi-98.com', 80, 280);
  doc.text('Website: taxi-98.com', 155, 280);
  
  doc.setFontSize(7);
  doc.setTextColor(224, 247, 250);
  doc.text('Nassau, New Providence, Bahamas • Est. 2026', 105, 290, { align: 'center' });
  
  return doc;
};

export const downloadReceiptPDF = (receipt) => {
  const doc = generateReceiptPDF(receipt);
  doc.save(`Taxi98-Receipt-${receipt.reference}.pdf`);
};

export const getReceiptPDFBlob = (receipt) => {
  const doc = generateReceiptPDF(receipt);
  return doc.output('blob');
};
